import moment from "moment-business-days";

export const SELLER_TYPE = {
    SELLER: 'v',
    TELEMARKETER: 't',
};

const START_HOUR = 8;
const END_HOUR = 18;
const DEFAULT_DURATION = 30; // 30 (minutes)

const DISABLED_HOURS = [];

for (let hour = 0; hour < START_HOUR; hour++) {
    DISABLED_HOURS.push(hour);
}

for (let hour = END_HOUR; hour <= 23; hour++) {
    DISABLED_HOURS.push(hour);
}

export const SELLER_TELEMARKETER_TIME_WORK = {
    START_HOUR,
    END_HOUR,
    DEFAULT_DURATION,
    DISABLED_HOURS,
    FROM: () => moment().hour(START_HOUR).minute(0).second(0).millisecond(0), // 9:00 AM
    TO: () => moment().hour(END_HOUR).minute(0).second(0).millisecond(0), // 6:00 PM
    MIDNIGHT: () => moment().hour(0).minute(0).second(0).millisecond(0), // 00:00
};
